import React from 'react';
import styled from "styled-components";
const IndexHeader = styled.div`
display: flex;
grid-template-columns: 1fr;
grid-template-rows: 1fr;
align-items: center;
justify-items: center;
// padding-top: 50px;
.image {
  //min-height: 85vh;
  width: 20%;
  grid-column: 1/1;
  grid-row: 1/1;
 
}
`;
const CompanyHeader = ({ img }) => {
    return (
        <IndexHeader>
            <img src={img} alt={"KYC document exchange"} className="image" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div>

            <p  css={{'margin-bottom':'0rem'}}><font face="Arial">Our digital repository has been designed to minimize manual input. It includes a number of</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">features specifically developed for KYC and other regulatory processes, including solutions</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">to the problem around frequent non-standard requests.  U-Reg’s repository solution helps</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">both document providers and recipients put behind them the repetitive process of exchanging</font></p>
                <p  css={{'margin-bottom':'0rem'}}><font face="Arial">multiple times the same documents with all their counterparts, through different channels.</font>
                </p>
            </div>
        </IndexHeader>
    );
};

export default CompanyHeader;
